module.exports = __webpack_public_path__ + "static/media/YM88_4.31e2cd2f.jpg";